import styled from 'styled-components';

const CustomInputSearch = styled.div`
    -webkit-overflow-scrolling: touch;

    input::-webkit-input-placeholder {
      color: #595959 !important;
    }

    ul{
      background-color: #FFF;
      padding: 3px;
      max-height: 350px;
      overflow-y: scroll;
      position: absolute;
      z-index: 9;
      width:98%;
    }
    ul li{padding: 2px; border-bottom: 1px #DDD solid; cursor:pointer;}
    ul li:hover{background-color:#e6f7ff; color: #1890ff}
`;
export { CustomInputSearch };